import { useState, useEffect } from "react";

// Avatar Component
export const AvatarComp = ({ name, image, size = "md" }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [image]);
  const initials =
    name
      ?.split(" ")
      .map((n) => n?.[0])
      .filter(Boolean)
      .join("")
      .slice(0, 2)
      .toUpperCase() || "?";
  const gradients = [
    "from-violet-500 to-purple-600",
    "from-cyan-500 to-blue-600",
    "from-emerald-500 to-teal-600",
    "from-orange-500 to-red-500",
    "from-pink-500 to-rose-600",
    "from-indigo-500 to-violet-600",
  ];
  const gradientIndex = (name?.charCodeAt(0) || 0) % gradients.length;
  const sizeClass =
    size === "sm"
      ? "w-8 h-8 text-xs"
      : size === "lg"
        ? "w-12 h-12 text-base"
        : size === "xl"
          ? "w-16 h-16 text-2xl"
          : "w-9 h-9 text-sm";

  if (!imgError && image) {
    return (
      <div
        className={`${sizeClass} rounded-full overflow-hidden ring-2 ring-white shadow-md flex-shrink-0`}
      >
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      </div>
    );
  }
  return (
    <div
      className={`${sizeClass} rounded-full bg-gradient-to-br ${gradients[gradientIndex]} flex items-center justify-center text-white font-semibold shadow-md flex-shrink-0`}
    >
      {initials}
    </div>
  );
};